import { render, staticRenderFns } from "./LookIframe.vue?vue&type=template&id=597d9d9c&scoped=true"
import script from "./LookIframe.vue?vue&type=script&lang=js"
export * from "./LookIframe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "597d9d9c",
  null
  
)

export default component.exports